import { useEffect } from "react";

import { useCountdown } from "hooks/useCountDown";
import Typography from "@mui/material/Typography";

const SECONDS_IN_MINUTE = 60;

type CountDownComponentProps = {
  expiresAt: string;
  onExpire?: () => void;
};

export const CountDownComponent = ({
  expiresAt,
  onExpire,
}: CountDownComponentProps) => {
  const { seconds } = useCountdown(expiresAt);

  useEffect(() => {
    if (seconds === 0 && onExpire) {
      onExpire();
    }
  }, [seconds]);

  if (seconds === 0) {
    return <Typography color="error.main">Expired</Typography>;
  }

  const minutes = Math.floor(seconds / SECONDS_IN_MINUTE);
  const remainingSeconds = seconds % SECONDS_IN_MINUTE;
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");

  return (
    <Typography>
      {minutes}m {formattedSeconds}s
    </Typography>
  );
};
